'use client';

import { createContext, type ReactNode, useContext } from 'react';

type MiniMapLaunch = () => Promise<boolean>;

const MiniMapLaunchContext = createContext<MiniMapLaunch | null>(null);

export function MiniMapLaunchProvider({ children, launch }: { children: ReactNode; launch: MiniMapLaunch }) {
    return <MiniMapLaunchContext.Provider value={launch}>{children}</MiniMapLaunchContext.Provider>;
}

export function useRemoteMiniMapLaunch(): MiniMapLaunch | null {
    return useContext(MiniMapLaunchContext);
}
